import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Color } from '../../../models/style/color.model';
import { LayoutService } from '../../../services/layout.service';

@Component({
    selector: 'lib-color-picker',
    templateUrl: './colorpicker.control.html',
    styleUrls: ['./colorpicker.control.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColorPickerComponent implements OnInit, AfterViewInit {

    //@ViewChild('gradientColorPickerElement') gradientColorPicker;

    CustomCSSVariables = [];
    SelectedCSSVariable;
    SelectedColorHex = '';
    SelectedColorHexAlpha = '';
    SelectedColorValue = new Color();
    Style = {};
    @Input()
    get SelectedColor() {
        return this.SelectedColorValue;
    }
    set SelectedColor(val) {
        if (val) {
            this.SelectedCSSVariable = val.ColorReference;
            this.SelectedColorHexAlpha = Color.HexFromColor(val);
            this.SelectedColorHex = Color.HexFromColor(val, true);
            this.SelectedColorValue = val;
        } else {
            this.SelectedCSSVariable = null;
            this.SelectedColorHexAlpha = '';
            this.SelectedColorHex = '';
            this.SelectedColorValue = new Color();
        }
        this.updateStyle(true);
        this.cdRef.detectChanges();
    }
    constructor(private cdRef: ChangeDetectorRef) {}

    UseVariablesValue = true;
    @Input()
    get UseVariables() {
        return this.UseVariablesValue;
    }
    set UseVariables(val) {
        this.UseVariablesValue = val;
    }

    UseSystemVariablesValue = true;
    @Input()
    get UseSystemVariables() {
        return this.UseSystemVariablesValue;
    }
    set UseSystemVariables(val) {
        this.UseSystemVariablesValue = val;
    }

    @Output() ColorChanged = new EventEmitter<Color>();
    onColorChanged() {
        this.ColorChanged.emit(this.SelectedColorValue);
    }

    InternalUpdate = false;

    ngOnInit(): void {
        if (this.UseVariablesValue) {
            if (this.UseSystemVariablesValue) {
                this.CustomCSSVariables = [...LayoutService.SystemCSSVariables, ...LayoutService.CustomCSSVariables];
            } else {
                this.CustomCSSVariables = [...LayoutService.CustomCSSVariables];
            }
        }
    }

    ngAfterViewInit(): void {
        //if (this.gradientColorPicker) {
        //    this.InternalUpdate = true;
        //    const hex = Color.HexFromColor(this.SelectedColorValue, true);
        //    if (hex) {
        //        this.gradientColorPicker.updateTmpSelectedColor(hex);
        //    } else {
        //        this.gradientColorPicker.updateTmpSelectedColor('#000000');
        //    }
        //    this.InternalUpdate = false;
        //}
    }

    pickerChanged(ev) {
        if (!this.InternalUpdate) {
            const color = Color.FromHex(ev.value);
            if (color.R !== this.SelectedColorValue.R || color.G !== this.SelectedColorValue.G || color.B !== this.SelectedColorValue.B) {
                color.A = this.SelectedColorValue.A;
                this.SelectedColor = color;
                this.onColorChanged();
            }
        }
    }

    hexChanged(ev) {
        if (ev && ev.currentTarget) {
            const hex = ev.currentTarget.value;
            this.SelectedColor = Color.FromHex(hex);
            this.onColorChanged();
        }
    }

    rgbaChanged() {
        this.onRGBAChange(true);
    }

    aChanged() {
        this.onRGBAChange(false);
    }

    onRGBAChange(updatePicker: boolean) {
        this.SelectedColorValue.ColorReference = null;
        this.SelectedCSSVariable = null;
        this.SelectedColorHex = Color.HexFromColor(this.SelectedColorValue, true);
        this.SelectedColorHexAlpha = Color.HexFromColor(this.SelectedColorValue);
        this.onColorChanged();
        this.updateStyle(updatePicker);
    }

    OnItemChanged() {
        this.SelectedColor = Color.FromReference(this.SelectedCSSVariable);
        this.onColorChanged();
    }

    updateStyle(updatePicker: boolean) {
        const result = {};
        result['background-color'] = Color.GetStyleText(this.SelectedColorValue);
        if (this.SelectedColorValue.R == null && this.SelectedColorValue.G == null && this.SelectedColorValue.B == null) {
            result['color'] = 'black';
        } else {
            const o =
                Math.round((this.SelectedColorValue.R * 299 + this.SelectedColorValue.G * 587 + this.SelectedColorValue.B * 114) / 1000);
            result['color'] = o > 125 ? 'black' : 'white';
        }
        this.Style = result;
        this.cdRef.detectChanges();
        //if (updatePicker) {
        //    const hex = Color.HexFromColor(this.SelectedColorValue, true);
        //    if (hex) {
        //        this.InternalUpdate = true;
        //        this.gradientColorPicker.updateTmpSelectedColor(hex);
        //        this.InternalUpdate = false;
        //    }
        //}
    }
}
